// Lightweight loader for Leaflet from CDN.
(function () {
  if (window.L && window.L.map) {
    return;
  }
  var script = document.createElement('script');
  script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  script.defer = true;
  script.crossOrigin = '';
  document.head.appendChild(script);
})();
